"use client";

import { useEffect } from "react";

export function HomeInteractive() {
  useEffect(() => {
    // 1. Initialize home script if available
    if (
      typeof window !== "undefined" &&
      typeof (window as unknown as { initializeHome?: () => void }).initializeHome ===
        "function"
    ) {
      (window as unknown as { initializeHome: () => void }).initializeHome();
    }

    // 2. Direct event delegation for video popup to ensure 100% reliability
    const handleVideoClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement | null;
      if (!target) return;

      const posterBtn = target.closest(".video-poster");
      if (posterBtn) {
        e.preventDefault();
        const dialog = document.querySelector<HTMLElement>(".video-dialog");
        if (dialog) {
          dialog.hidden = false;
          posterBtn.setAttribute("aria-pressed", "true");
          document.body.style.overflow = "hidden";

          const iframe = dialog.querySelector<HTMLIFrameElement>("iframe");
          if (iframe) {
            const dataSrc =
              iframe.dataset.src ||
              "https://www.youtube.com/embed/nyGhrWzEYlg";
            try {
              const url = new URL(dataSrc, window.location.href);
              url.searchParams.set("autoplay", "1");
              url.searchParams.set("rel", "0");
              iframe.src = url.toString();
            } catch {
              iframe.src = "https://www.youtube.com/embed/nyGhrWzEYlg?autoplay=1&rel=0";
            }
          }

          const closeBtn = dialog.querySelector<HTMLButtonElement>(
            ".video-dialog-close"
          );
          closeBtn?.focus();
        }
        return;
      }

      const closeBtn = target.closest(".video-dialog-close");
      const isDialogBackdrop = target.classList.contains("video-dialog");
      if (closeBtn || isDialogBackdrop) {
        e.preventDefault();
        const dialog = document.querySelector<HTMLElement>(".video-dialog");
        if (dialog) {
          dialog.hidden = true;
          document.body.style.overflow = "";

          const poster = document.querySelector<HTMLElement>(".video-poster");
          poster?.setAttribute("aria-pressed", "false");

          const iframe = dialog.querySelector<HTMLIFrameElement>("iframe");
          if (iframe) {
            iframe.removeAttribute("src");
          }
        }
      }
    };

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        const dialog = document.querySelector<HTMLElement>(".video-dialog");
        if (dialog && !dialog.hidden) {
          dialog.hidden = true;
          document.body.style.overflow = "";

          const poster = document.querySelector<HTMLElement>(".video-poster");
          poster?.setAttribute("aria-pressed", "false");

          const iframe = dialog.querySelector<HTMLIFrameElement>("iframe");
          if (iframe) {
            iframe.removeAttribute("src");
          }
        }
      }
    };

    document.addEventListener("click", handleVideoClick);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("click", handleVideoClick);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return null;
}
